"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynBankCardInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPay_1 = require("../../model/hsPay");
var service_1 = require("../../../library/base/service");
var SynBankCardInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SynBankCardInfo, _super);
    function SynBankCardInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '同步更新银行卡信息接口';
        _this.code = '105037';
        _this.desc = '同步更新银行卡信息接口';
        _this.requestParams = new hsPay_1.SynBankCardInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SynBankCardInfo;
}(service_1.BaseService));
exports.SynBankCardInfo = SynBankCardInfo;
//# sourceMappingURL=synBankCardInfo.js.map